import React from 'react';
import {
    AlertDialog,
    AlertDialogBody,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogContent,
    AlertDialogOverlay,
    Button,
    Box,
    Flex,
    useColorModeValue
} from '@chakra-ui/react';
import { IconWrapper } from './UiElements';
import useStore from '../stores/store';

interface DeleteWsModalProps {
    isOpen: boolean;
    onClose: () => void;
    isOwner: boolean;
    wsName: string;
    id: string;
}

const DeleteWsModal: React.FC<DeleteWsModalProps> = ({
    isOpen,
    onClose,
    isOwner,
    wsName,
    id
}) => {
    const modalBg = useColorModeValue('#FFF', '#262A2D');

    const deleteWorkspace = () => {
        useStore.getState().deleteWorkspace(id, isOwner);
        onClose();
    };

    const cancelRef = React.useRef();

    return (
        <AlertDialog
            isOpen={isOpen}
            leastDestructiveRef={cancelRef}
            onClose={onClose}
        >
            <AlertDialogOverlay>
                <AlertDialogContent rounded="12px" bg={modalBg}>
                    <AlertDialogHeader
                        fontSize="lg"
                        fontWeight="bold"
                        pb="4px"
                        mt="12px"
                        display="flex"
                        alignContent="center"
                        paddingRight="44px"
                    >
                        <Flex
                            p="4px"
                            mr="16px"
                            bg="#ff4b4a30"
                            rounded="10px"
                            alignContent="center"
                            alignItems="center"
                            minW="54px"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-5 w-5"
                                viewBox="0 0 20 20"
                                fill="#ff4b4a"
                                style={{
                                    width: '32px',
                                    height: '32px',
                                    margin: 'auto'
                                }}
                            >
                                <path
                                    fillRule="evenodd"
                                    d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                                    clipRule="evenodd"
                                />
                            </svg>
                        </Flex>
                        Are you sure you want to {isOwner ? 'delete' : 'remove'}{' '}
                        this workspace?
                    </AlertDialogHeader>
                    <AlertDialogBody fontSize={'14px'}>
                        {isOwner
                            ? 'All containing categories, groups and saved items will be deleted for all users.'
                            : "You won't have access to the workspace again. The workspace will still be available for other users."}
                    </AlertDialogBody>
                    <AlertDialogFooter px="16px">
                        <Button ref={cancelRef} onClick={onClose} rounded="8px">
                            Cancel
                        </Button>
                        <Button
                            bg={'#e53b3a'}
                            onClick={deleteWorkspace}
                            ml={3}
                            rounded="8px"
                            transition={'0.1s'}
                            _hover={{ bg: '#c53131' }}
                            color={'#FFF'}
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 20 20"
                                fill="#FFF"
                                style={{
                                    width: '16px',
                                    height: '16px',
                                    margin: 'auto 8px auto 0px'
                                }}
                            >
                                <path
                                    d="M9 2C8.62123 2 8.27497 2.214 8.10557 2.55279L7.38197 4H4C3.44772 4 3 4.44772 3 5C3 5.55228 3.44772 6 4 6L4 16C4 17.1046 4.89543 18 6 18H14C15.1046 18 16 17.1046 16 16V6C16.5523 6 17 5.55228 17 5C17 4.44772 16.5523 4 16 4H12.618L11.8944 2.55279C11.725 2.214 11.3788 2 11 2H9ZM7 8C7 7.44772 7.44772 7 8 7C8.55228 7 9 7.44772 9 8V14C9 14.5523 8.55228 15 8 15C7.44772 15 7 14.5523 7 14V8ZM12 7C11.4477 7 11 7.44772 11 8V14C11 14.5523 11.4477 15 12 15C12.5523 15 13 14.5523 13 14V8C13 7.44772 12.5523 7 12 7Z"
                                    fillRule="evenodd"
                                />
                            </svg>
                            {isOwner ? 'Delete' : 'Remove'} {wsName}
                        </Button>
                    </AlertDialogFooter>
                </AlertDialogContent>
            </AlertDialogOverlay>
        </AlertDialog>
    );
};

export default DeleteWsModal;
